import { createSlice } from '@reduxjs/toolkit'

import type { RootState } from '../store'

import { actionTypes } from './types'

type AppState = {
  isInit: boolean
  cookiesSettings: boolean
}

//
// Initial state
//

const initialState: AppState = {
  isInit: false,
  cookiesSettings: false,
}

//
// Slice (Actions & Reducers)
//

const slice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    init: () => undefined,
    setIsInit: (state, action: actionTypes.setIsInit) => {
      const { isInit } = action.payload
      state.isInit = isInit
    },
    openCookiesSettings: (state) => {
      state.cookiesSettings = true
    },
    closeCookiesSettings: (state) => {
      state.cookiesSettings = false
    },
  },
})

export const { reducer, actions } = slice

//
// Selectors
//

const root = (state: RootState) => state[slice.name]
const isInit = (state: RootState) => root(state).isInit
const cookiesSettings = (state: RootState) => root(state).cookiesSettings

export const selectors = {
  isInit,
  cookiesSettings,
}
